import React, { useEffect, useState } from "react";
import axios from "axios";
import { generateAuthHeader, API, api_url } from "../../util/util";
import { useNavigate } from "react-router-dom";
import { createClient } from "@supabase/supabase-js";
import axiosRetry from "axios-retry";
import { FaSearch } from "react-icons/fa"; // Importing the search icon
import vector from "../../assets/img/Vector1.png"; // Importing the search icon
import Union from "../../assets/img/Union.png";

axiosRetry(axios, {
  retries: 3,
  retryDelay: axiosRetry.exponentialDelay,
});

const supabaseUrl = process.env.REACT_APP_SUPABAE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASEKEY;
const supabase = createClient(supabaseUrl, supabaseKey);

function SearchBar() {
  const [islogin, setIsLoggedIn] = useState(false);
  const [query, setQuery] = useState("");
  const [paramater, setParameter] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const navigate = useNavigate();
  const isLoggedIn = localStorage.getItem("login") === "true";

  useEffect(() => {
    const checkUser = async () => {
      const { data } = await supabase.auth.getUser();
      if (data.user === null) {
        localStorage.removeItem("login");
        localStorage.removeItem("sb-hnfcpioavnlsyqepkgxo-auth-token");
        setIsLoggedIn(false);
        navigate("/");
      }
    };
    checkUser();

    if (!isLoggedIn) {
      navigate("/");
    }
  }, [isLoggedIn, navigate]);

  const handleChange = async (e) => {
    const { value } = e.target;
    setQuery(value);

    if (value.trim() === "") {
      setSuggestions([]);
      return;
    }

    const url = `${api_url}/${API.ENDPOINTS.search}?name=${value}`;
    try {
      const response = await axios.get(url, {
        headers: {
          Authorization: generateAuthHeader(),
        },
      });

      if (response.status === 200) {
        setSuggestions(response.data.companies);
      } else {
        console.error("Unexpected response");
      }
    } catch (error) {
      console.error("Error fetching suggestions:", error);
    }
  };

  const handleClick = (suggestion) => {
    setQuery(suggestion.name);
    setParameter(suggestion.permalink);
    setSuggestions([]);
    navigate(`/details?query=${suggestion.permalink}`);
  };

  return (
    <section className="spad">
      <img
        src={vector}
        alt="Top Left Icon"
        className="position-absolute bottom-left-icon"
      />
      <img
        src={Union}
        alt="Bottom Right Icon"
        className="bottom-right-icon"
      />

      {/*  */}
      <div className="text-div text-center">
        <div className="text-contentetn">
          <div className="w-100 sub-heding-main justify-content-center d-flex">
            <div className="hading-spen-main">
              <h6 className="hading-spen-main-title">Where Knowledge Begins</h6>
            </div>
          </div>
          <div className="hading-main w-100 justify-content-center d-flex">
            <h2 className="hading-main-title">Uncover Detailed Startup <b className="h2 hading-main-title-defrent-colore">Insights</b></h2>
          </div>

        </div>
        <div className="text-center justify-content-center d-flex inner-div">
          <div className="Search-input-container">
            <FaSearch className="search-icon" />
            <input
              className="Search-input"
              type="text"
              value={query}
              onChange={handleChange}
              placeholder="Search by company name..."
            />
          </div>
          <ul className="suggestions-list">
            {suggestions.map((suggestion, index) => (
              <li key={index} onClick={() => handleClick(suggestion)}>
                <span className="small-description">
                  {suggestion.name}
                </span>
                <br />
                <span>
                  {suggestion.description}
                </span>
                <hr />
              </li>
            ))}
          </ul>
        </div>
      </div>

    </section>
  );
}
export default SearchBar;
